<template>
  <div id="auth">
    <form v-on:submit.prevent="_checkEmail" novalidate>
      <img src="../assets/UJET-logo.png">
      <input v-model.trim="email" maxlength="50" v-validate="'company_exists|required|email|max:50|email_verified'" class="text-fill w-input" name="email" data-vv-as="Email" data-vv-delay="500" placeholder="Email">
      <span  v-show="errors.has('email')" class="warning">{{ errors.first('email') }}</span>
      
      <button class="button1 margin-top-30 w-button" type="submit">Let me in</button>

    </form>
  </div>
</template>

<script>
import auth from '../services/auth.service'
import { Validator } from 'vee-validate';

Validator.extend('email_verified', {
  getMessage: () => 'This email address does not have access',
  validate: value => new Promise(async (resolve) => resolve(await auth.checkEmail(value)))
});

Validator.extend('company_exists', {
  getMessage: () => 'Please enter a valid subdomain',
  validate: () => new Promise(async (resolve) => resolve(await auth.companyExists()))
});

export default {
  name: 'Auth',
  data() {
    return {
      email: ''
    }
  },
  methods: {
    async _checkEmail() {
      const valid = await this.$validator.validateAll();
      if(valid) {
        this.$store.commit('setEmail', this.email);
        this.$store.commit('setLogin', true);
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
  #auth {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  form{
    display: flex;
    flex-direction: column;
    width: 400px;
    position: relative;
  }

  img{
    max-width: 160px;
    margin: 0 auto 30px auto;
  }

  input{
    padding: 10px;
    font-size: 30px;
    margin-bottom: 50px;
    text-align: center;
    outline: none;
  }

  button{
    cursor: pointer;
    padding: 15px;
    border-radius: 30px;
    font-size: 18px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #fff;
    background-image: linear-gradient(90deg, #78d8ff, #4990e2 43%, #060e97);
  }
  .warning{
    color: red;
    text-align: center;
    padding: 15px;
    position: absolute;
    top: 170px;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/Auth.vue